import { memo, useEffect, useRef, useState } from "react";
import { MarkerF, MarkerClusterer } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedProperty } from "@/redux/SRP/srpSlice";
import MarkerEmptyTooltip from "./MarkerEmptyTooltip";
import { trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";

const MapClusters = ({propertyData, setPropertyData, setMapParams}) => {
  const dispatch = useDispatch();
  const markerClusterRef = useRef(null);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [loading, setLoading] = useState(true);
  const {selectedProperty} = useSelector((state) => state.srp);
  const srpTupples = useSelector((state) => state.srp.srpInitData.srpTupples);
  const {isAddedToSaved} = useSelector((state) => state.savedPreference);

  useEffect(() => {
    if (propertyData?.length > 64 && selectedProperty && markerClusterRef?.current) {
      const allClusters = markerClusterRef?.current?.state?.markerClusterer?.getClusters();
      allClusters?.length > 0 && allClusters.map(cluster => {
        const markers = cluster?.getMarkers();
        markers?.length > 0 && markers.map(markerItem => {
          const lat = markerItem?.position?.lat();
          const lng = markerItem?.position?.lng();
          if (Number(selectedProperty?.lat) === lat && Number(selectedProperty?.lng) === lng) {
            const center = cluster?.getCenter();
            const centerPoint = {lat: center.lat(), lng: center.lng()}
            const markerLength = markers?.length + '';
            setSelectedCluster({...selectedProperty, ...centerPoint, clusterTitle: markerLength?.length})
          }
        })
      });
    } else {
      setSelectedCluster(null)
    }
  }, [selectedProperty, propertyData?.length, markerClusterRef?.current]);

  useEffect(() => {
    if (srpTupples.length > 0 && markerClusterRef?.current) {
      const allClusters = markerClusterRef?.current?.state?.markerClusterer?.getClusters();
      allClusters?.length > 0 && allClusters.map(cluster => {
        const markers = cluster?.getMarkers();
        let allMarkerSave = false;
        markers?.length > 0 && markers.map(markerItem => {
          const lat = markerItem?.position?.lat();
          const lng = markerItem?.position?.lng();
          let isSaved = false;
          srpTupples?.length > 0 && srpTupples.map(tupple => {
            if (Number(tupple?.lat) === lat && Number(tupple?.lng) === lng && tupple?.onWatchList === "Y") {
              isSaved = true;
            }
          });
          if (isSaved) {
            allMarkerSave = true;
            let heartDiv = cluster?.clusterIcon?.div?.getElementsByTagName("img");
            let hasDiv = heartDiv?.length > 0 && heartDiv[0];
            if (hasDiv) {
              hasDiv.classList.add('showImg');
            }
          } else if (!allMarkerSave) {
            let heartDiv = cluster?.clusterIcon?.div?.getElementsByTagName("img");
            let hasDiv = heartDiv?.length > 0 && heartDiv[0];
            if (hasDiv) {
              hasDiv.classList.remove('showImg');
            }
          }
        })
      });
    }
  }, [srpTupples, loading, isAddedToSaved])

  const onClusterClicked = (map) => {

    trackButtonClick({
      eventName: "cluster_click",
      eventSource: "Map Cluster Interaction",
      eventCategory: "NEW-SRP",
      eventLabel: `Location: ${getSrpLocationLabel()}`,
    });

    const markerLength = map.getMarkers()?.length;
    if (map && markerLength < 64) {
      setPropertyData([]);
      dispatch(setSelectedProperty(null));
      const LatLngBounds = map.getBounds();
      const center = map.getCenter();
      const params = {
        swLatLng: `${LatLngBounds.getSouthWest().lat()},${LatLngBounds.getSouthWest().lng()}`,
        neLatLng: `${LatLngBounds.getNorthEast().lat()},${LatLngBounds.getNorthEast().lng()}`,
        centerPoint: `${center.lat()},${center.lng()}`,
        rect: true,
      };
      setMapParams(params);
    }
  };

  return (
    <div>
      <MarkerClusterer
        onClick={(e) => onClusterClicked(e)}
        ref={markerClusterRef}
        clusterClass='map-cluster-icon'
        minimumClusterSize={1}
        onMouseOver={(e) => {
          const center = e.getCenter();
          const centerPoint = {lat: center.lat(), lng: center.lng()}
          const markerLength = e?.markers?.length + '';
          setSelectedCluster({...centerPoint, clusterTitle: markerLength?.length, scrollTo: false})
        }}
        onMouseOut={() => setSelectedCluster(null)}
        onClusteringEnd={() => setTimeout(() => {
          setLoading(false);
        }, 200)}
        onClusteringBegin={() => setLoading(true)}
      >
        {(clusterer) =>
          clusterer && propertyData?.length > 0 && propertyData.map((marker, index) => {
            return (
              <MarkerF
                key={`clusterer-${marker.lat}-${marker.lng}-${index}`}
                position={{
                  lat: Number(marker.lat),
                  lng: Number(marker.lng),
                }}
                tracksViewChanges={true}
                clusterer={clusterer}
              />
            )
          })}
      </MarkerClusterer>
      {propertyData?.length > 64 && selectedCluster !== null && (
        <MarkerEmptyTooltip item={selectedCluster} closeCardHandler={() => selectedCluster(null)} />
      )}
    </div>
  );
}
export default memo(MapClusters);